import React, { useState } from "react";

const UserForm = ({ onUserAdded }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username,
          password,
          role: "gerant",
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || (data.errors && data.errors[0]?.msg) || "Erreur lors de la création");
      }

      setMessage({ type: "success", text: `✅ Gérant ${data.user} ajouté.` });
      setUsername("");
      setPassword("");

      if (onUserAdded) onUserAdded(); // 🔁 callback pour recharger la liste
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#1A1A1A] p-6 rounded-lg shadow-lg space-y-4 max-w-md w-full mx-auto"
    >
      <h3 className="text-xl font-bold text-white text-center">Ajouter un nouveau gérant</h3>

      <div className="flex flex-col">
        <label className="text-sm text-gray-300 mb-1">Nom d’utilisateur</label>
        <input
          type="text"
          className="px-4 py-2 rounded bg-[#2C2C2C] text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm text-gray-300 mb-1">Mot de passe</label>
        <input
          type="password"
          className="px-4 py-2 rounded bg-[#2C2C2C] text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className={`w-full py-2 rounded text-white font-semibold transition ${
          loading ? "bg-gray-600 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
        }`}
      >
        {loading ? "Ajout en cours..." : "Ajouter"}
      </button>

      {message && (
        <p
          className={`text-sm text-center mt-2 ${
            message.type === "success" ? "text-green-400" : "text-red-400"
          }`}
        >
          {message.text}
        </p>
      )}
    </form>
  );
};

export default UserForm;
